import { proxy } from "valtio";

interface MapDataProps {
  activeCategory: "prevalence" | "vulnerability" | "gov-response";
  showProducts: boolean;
  showProductsMobile: boolean;
  productsCountry: string;
  selectedProduct: string;
  hoveredPolygonIndex: number;
  year: "2018" | "2023";
  viewState: any;
}

const mapData: MapDataProps = proxy({
  activeCategory: "prevalence",
  showProducts: false,
  showProductsMobile: false,
  productsCountry: null,
  selectedProduct: null,
  hoveredPolygonIndex: null,
  year: "2023",
  mapLayers: [],
  viewState: {
    latitude: 44,
    longitude: 3.25,
    zoom: -4,
    bearing: 0,
    pitch: 0,
    target: [0, 0, 0],
  },
});

export default mapData;
